module.exports = "<router-outlet><app-spinner></app-spinner></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/apostolos/Documents/globalrank/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main